import { Link } from "react-router-dom";
import { Calendar, Mail, HeartHandshake, HandHeart, Handshake, Wallet, ArrowRight } from "lucide-react";

const WAYS = [
  { icon: Calendar, title: "Partecipa a un evento", desc: "Trova l'incontro giusto per te sul calendario aggiornato.", to: "/eventi", cta: "Vai al calendario" },
  { icon: Mail, title: "Iscriviti agli aggiornamenti", desc: "Ricevi in anteprima nuovi eventi, storie e materiali.", to: "/contatti?kind=newsletter", cta: "Iscriviti alla newsletter" },
  { icon: HeartHandshake, title: "Diventa socio/a", desc: "Sostieni la vita associativa e partecipa alle decisioni.", to: "/partecipa#socio", cta: "Voglio associarmi" },
  { icon: HandHeart, title: "Fai volontariato", desc: "Un pomeriggio, un evento, un progetto: c'è spazio per tutti i tempi.", to: "/partecipa#volontariato", cta: "Candidati" },
  { icon: Handshake, title: "Proponi una collaborazione", desc: "Sei una scuola, un ente, un/a professionista? Raccontaci la tua idea.", to: "/partecipa#collabora", cta: "Contattaci" },
  { icon: Wallet, title: "Sostieni Vola Vola", desc: "Bonifico, 5×1000, PayPal o Satispay: ogni gesto conta.", to: "/partecipa#sostieni", cta: "Sostienici" },
];

export default function EntraNellaComunita() {
  return (
    <div data-testid="entra-comunita-page">
      <section className="bg-[#FFF1E8] py-20 lg:py-24 relative overflow-hidden">
        <div className="absolute -top-32 -right-32 w-96 h-96 blob bg-[#FF6100]/15 -z-0" />
        <div className="container-vv relative">
          <div className="eyebrow">Entra nella comunità</div>
          <h1 className="mt-4 font-display font-medium text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#292522] max-w-4xl">
            Sei più di un <span className="text-[#FF6100]">destinatario:</span> sei parte della comunità.
          </h1>
          <p className="mt-6 text-lg text-[#292522]/80 max-w-3xl leading-relaxed">
            Ci sono tanti modi per stare dentro Vola Vola. Scegli quello che ti somiglia in questo momento della tua vita — puoi cambiare, aggiungere, sperimentare. Le porte restano aperte.
          </p>
        </div>
      </section>

      <section className="container-vv py-16 lg:py-20">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {WAYS.map((w, i) => {
            const Icon = w.icon;
            return (
              <Link key={i} to={w.to} className="card-vv bg-white p-8 group hover:-translate-y-1 transition-transform" data-testid={`way-${i}`}>
                <div className="h-12 w-12 rounded-2xl bg-[#FF6100]/12 flex items-center justify-center text-[#FF6100] mb-5">
                  <Icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-2xl font-medium text-[#292522] group-hover:text-[#FF6100] transition-colors">{w.title}</h3>
                <p className="mt-2 text-[#292522]/70 leading-relaxed">{w.desc}</p>
                <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF6100]">{w.cta} <ArrowRight className="h-4 w-4" strokeWidth={1.75} /></div>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="container-vv pb-24">
        <div className="rounded-[2rem] bg-[#292522] text-[#FFFCF8] p-10 lg:p-16 relative overflow-hidden">
          <div className="absolute -top-16 -right-16 w-56 h-56 blob bg-[#FF6100]/30 pointer-events-none" />
          <div className="relative max-w-2xl">
            <div className="eyebrow text-[#FF6100]">Prima volta?</div>
            <h2 className="mt-3 font-display font-medium text-4xl">Il modo più semplice per conoscerci è venire a un evento.</h2>
            <p className="mt-4 text-[#FFFCF8]/70">La partecipazione è quasi sempre gratuita e su iscrizione. Nessun impegno, nessun modulo complicato: solo presenza e curiosità.</p>
            <Link to="/eventi" className="btn-primary mt-6 inline-flex"><Calendar className="h-4 w-4" strokeWidth={1.75} />Vedi i prossimi eventi</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
